import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { requestPartner } from "../../apis/partner/partner";
import { MENUS } from "../../constants/MENU";
import { newWindow } from "../../utils/browser";
import systemAlert from "../../utils/systemAlert";
import setTrialType, { setTrialRequestPartners } from "../../utils/trial";
import Button from "../Button";
import Modal from "../Modal";
import ToolTip from "../ToolTip/ToolTip";
import TrialImage from "../../assets/images/trial/trial-image.svg";
import Icon from "../Icon";
import { USER_GUIDE_URL } from "../../utils/user-guide";
export const TrialInfoModal = () => {
  const [trialData, setTrialData] = useState("");

  const {
    trialType,
    company,
    // employee
  } = useSelector(
    (store) => ({
      // employee: store.Profile.employee,
      trialType: store.Data.trialType,
      company: store.Profile.company,
    }),
    shallowEqual
  );
  useEffect(() => {
    if (trialType) setTrialData(MENUS.find((m) => m.id === trialType));
    else setTimeout(setTrialData(null), 500);
  }, [trialType]);

  const close = () => {
    setTrialType(null);
  };

  const fullVersionRequest = async (e) => {
    const code = company.throughTaxCompanyCode;
    const taxCompany = company.throughTaxCompanyCodeCompany;
    const awaitTaxCompnay = get(company, "taxCompanyCodeCompany");
    // const ceo = company.ceo
    // const isCeo = ceo.employeeIdx === employee.employeeIdx
    if (awaitTaxCompnay) {
      systemAlert(`"${awaitTaxCompnay.name}" 세무사에 요청중입니다.\n세무사 승인후 사용하실수 있습니다.`);
      // TODO 요청 취소 버튼 필요
      // systemAlert(`${awaitTaxCompnay.name}에 요청중입니다. 다른 세무사를 찾아 보시겠습니까?`, {
      //   buttons: [
      //     {
      //       color: "text",
      //       label: "다른 세무사에게 요청",
      //       onClick: () => {
      //         setTrialRequestPartners();
      //       },
      //     },
      //     {
      //       label: `${awaitTaxCompnay.name}에 계속 요청`,
      //       onClick: async () => {},
      //     },
      //   ],
      // });

    } else if (code && taxCompany) {

      systemAlert(`${taxCompany.name}를(을) 담당 세무사로 요청 하시겠습니까?`, {
        buttons: [
          {
            color: "text",
            label: "취소",
          },
          {
            label: `${taxCompany.name}에 요청`,
            onClick: async () => {
              await requestPartner(company.idx, code);
              systemAlert(`${taxCompany.name}에 담당 세무사 요청 했습니다.`);
            },
          },
        ],
      });
      // systemAlert(`${taxCompany.name}를(을) 담당 세무사로 요청 하시겠습니까?\n다른 요청이 있는 경우 기존 요청은 취소 됩니다.`, {
      //   buttons: [
      //     {
      //       color: "text",
      //       label: "다른 세무사에게 요청",
      //       onClick: () => {
      //         setTrialRequestPartners();
      //       },
      //     },
      //     {
      //       label: `${taxCompany.name}에 요청`,
      //       onClick: async () => {
      //         await requestPartner(company.idx, code);
      //         systemAlert(`${taxCompany.name}에 담당 세무사 요청 했습니다.`)
      //       },
      //     },
      //   ],
      // });
    } else {
      setTrialRequestPartners();
    }
  };

  return (
    <Modal className="trial-modal" size="xx-lg" isOpen={!!trialType} close={close}>
      {trialData && (
        <>
          <div className="trial-container">
            <div className="trial-contents">
              <div className="trial-description">
                <div className="trial-description-box">
                  <div className="text">
                    <strong>위케이크 파트너 세무사</strong>와 함께!<br />
                    <strong>경리지원 혹은 기장대리 서비스</strong> 이용하면<br />
                    <span className="point"><strong>wecake솔루션</strong>의 모든 기능을</span><br />
                    <strong className="point">무료</strong>로 사용할 수 있어요.
                  </div>
                  <div className="trial-description-button-wrap">
                    <Button
                      style={{
                        width: '100%'
                      }}
                      onClick={(e) => fullVersionRequest(e)}
                    >
                      무료로 풀버전 사용하기&nbsp;
                      <ToolTip
                        tooltiptext={
                          "이외 메뉴 사용을 원하신다면\n wecake파트너 세무사와 상담하세요."
                        }
                      />
                    </Button>
                    <div className="buttons">
                      <Button
                        color="text"
                        onClick={(e) =>
                          newWindow(
                            "https://www.youtube.com/channel/UCbpaB_D8CVLE81QapgArgBg",
                            e
                          )
                        }
                      >
                        wecake TV
                        {/* <ToolTip
                          tooltiptext={
                            "wecake의 기능을 영상으로\n 자세히 설명 듣고 싶다면\n wecakeTV에서 확인하세요. "
                          }
                        /> */}
                      </Button>
                      <Button
                        color="text"
                        onClick={(e) => newWindow(USER_GUIDE_URL, e)}
                      >
                        이용가이드
                      </Button>
                      <Button
                        color="text"
                        onClick={(e) => newWindow("https://yds.ai/", e)}
                      >
                        홈페이지
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="trial-image-box">
                  <img src={TrialImage} alt='위케이크' />
                </div>
              </div>
              <div className="trial-description-line"></div>
              <div className="trial-description">
                {trialData.trialImage && (
                  <div className="trial-image-box">
                    <img src={trialData.trialImage} alt={trialData.label} />
                  </div>
                )}
                <div className="trial-menu-description">
                  <div className="trial-title">
                    {trialData.icon && (trialData.icon.indexOf('bxs') === -1) ?
                      <Icon src={trialData.icon} className="menu-icon" /> :
                      <i className={'menu-icon icon ' + trialData.icon}></i>
                    }
                    {trialData.label}
                  </div>
                  {trialData.text && (
                    <div className="trial-text">{trialData.text}</div>
                  )}
                  {trialData.children && (
                    <div className="trial-sub-info-list">
                      {trialData.children.map((item, idx) => (
                        <div className="trial-sub-info" key={idx}>
                          <span className="title">{item.label}</span>
                          <span className="text">{item.text}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};
